var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", { attrs: { label: "Imóvel" } }),
      _c(
        "el-row",
        { staticClass: "pad5" },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.labelsCadastro.imovel.denominacao))
              ]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.filterNull(_vm.imovel.denominacao)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.labelsCadastro.imovel.colonia))
              ]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.filterNull(_vm.imovel.gleba)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("Área:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.formatterNumber(_vm.imovel.area)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("Município:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v(
                  "  " + _vm._s(_vm.filterMunicipioNull(_vm.imovel.municipio))
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c("app-divider", { attrs: { label: "Matrícula/Título" } }),
      _c(
        "el-row",
        { staticClass: "pad5" },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("CNS:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.filterNull(_vm.imovel.cnsMatricula)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("Número:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v(
                  "  " + _vm._s(_vm.filterNull(_vm.imovel.numeroMatricula))
                )
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("Livro:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.filterNull(_vm.imovel.livroMatricula)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [_vm._v("Nº da folha:")]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v(
                  "  " + _vm._s(_vm.filterNull(_vm.imovel.numeroFolhaMatricula))
                )
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v("Data do registro:")
              ]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.formatDate(_vm.imovel.dataRegistro)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v("Nome beneficiário título:")
              ]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v(
                  "  " +
                    _vm._s(_vm.filterNull(_vm.imovel.nomeBeneficiarioTitulo))
                )
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v("Nome do cartório:")
              ]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v("  " + _vm._s(_vm.filterNull(_vm.imovel.nomeCartorio)))
              ])
            ])
          ]),
          _c("el-col", { attrs: { span: 12 } }, [
            _c("p", [
              _c("span", { staticClass: "label" }, [
                _vm._v("Município do cartório:")
              ]),
              _c("span", { staticClass: "breakText" }, [
                _vm._v(
                  "  " +
                    _vm._s(_vm.filterNull(_vm.imovel.municipioCartorio.nome))
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c("app-resumo-documentos", {
        staticClass: "margin-top",
        attrs: {
          documentos: _vm.imovel.documentos,
          codigoCadastro: "imovel",
          idCadastro: _vm.idCadastro
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e0a75e1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e0a75e1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/maranhao/liberacao/components/ResumoImovel.vue
// module id = null
// module chunks = 